import React, { useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import login from '../../API/login';
import './Login.css';
import { AuthContext } from '../../../App';

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const { updateLoginStatus } = useContext(AuthContext);

  const handleFormSubmission = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const formValues = Object.fromEntries(formData.entries());

    try {
      const response = await login({
        email: formValues.email,
        password: formValues.password,
        rememberMe: formValues['remember-me'] === 'on',
      });

      if (response.success) {
        console.log('Login successful:', response);
        setSuccessMessage('Login successful! Redirecting...');
        updateLoginStatus(true);
        setTimeout(() => {
          const origin = location.state?.from || '/';
          navigate(origin);
        }, );
      } else {
        console.error('Login failed:', response.message);
        setErrorMessage(response.message);
      }
    } catch (error) {
      console.error('Error during login:', error);
      setErrorMessage('An error occurred. Please try again later.');
    }
  };

  const handleFacebookLogin = () => {
    console.log('Initiating Facebook login process');
    // Facebook login logic here
  };

  const handleGoogleLogin = () => {
    console.log('Initiating Google login process');
    // Google login logic here
  };

  return (
    <div className="login-container">
      <h2 className="login-title">Login</h2>
      {errorMessage && <p className="error-message">{errorMessage}</p>}
      {successMessage && <p className="success-message">{successMessage}</p>}
      <form onSubmit={handleFormSubmission} className="login-form">
        <div className="login-form-group">
          <input type="text" id="email" name="email" className="login-input" placeholder=" " required />
          <label htmlFor="email" className="login-label">Email or Username</label>
        </div>
        <div className="login-form-group">
          <input type="password" id="password" name="password" className="login-input" placeholder=" " required />
          <label htmlFor="password" className="login-label">Password</label>
        </div>
        <div className="login-options">
          <div className="login-remember">
            <input type="checkbox" id="remember-me" name="remember-me" className="login-checkbox" />
            <label htmlFor="remember-me" className="login-checkbox-label">Remember me</label>
          </div>
          <button type="button" className="login-forgot-password" onClick={() => navigate('/forgot-password')}>
            Forgot your password?
          </button>
        </div>
        <button type="submit" className="login-submit-btn">Log in</button>
      </form>
      <div className="login-divider"><span>or</span></div>
      {/* <button className="login-social-btn" onClick={handleFacebookLogin}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="#1877F2"><path d="M22.675 0H1.325C.593 0 0 .593 0 1.325v21.351C0 23.407.593 24 1.325 24H12.82v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116c.73 0 1.323-.593 1.323-1.325V1.325C24 .593 23.407 0 22.675 0z"/></svg>
        Login with Facebook
      </button>
      <button className="login-social-btn" onClick={handleGoogleLogin}>
        <svg width="20" height="20" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
        Login with Google
      </button> */}
      <p className="login-signup-link">
        Don't have an account? <button className="login-signup-anchor" onClick={() => navigate('/create-account')}>Sign up</button>
      </p>
    </div>
  );
};

export default Login;
